import { watch } from "fs";

export const ServerBaseUrl = "https://api.learnfrommike.org/api/v1";

export const ServerRoutes = {
  login: `https://api.learnfrommike.org/api/v1/admin/auth/login`,
  users: `https://api.learnfrommike.org/api/v1/admin/users`,
  userTree: `https://api.learnfrommike.org/api/v1/admin/user`,
  bd: `https://api.learnfrommike.org/api/v1/admin/bd`,
  saleReport: `https://api.learnfrommike.org/api/v1/admin/sale-report`,
  saleTransactions: `https://api.learnfrommike.org/api/v1/admin/transactions/sale`,
  stats: `https://api.learnfrommike.org/api/v1/admin/stats`,
  communitySale: `https://api.learnfrommike.org/api/v1/admin/community-sales-volumes`,
  subscriptions: `https://api.learnfrommike.org/api/v1/admin/subscriptions`,
  courses: `https://api.learnfrommike.org/api/v1/admin/courses`,
  courseWatchProgress: `https://api.learnfrommike.org/api/v1/admin/dashboard/watch-progress`,
  courseSeasons: `https://api.learnfrommike.org/api/v1/admin/course-seasons`,
  courseItems: `https://api.learnfrommike.org/api/v1/admin/course-items`,
};
